import {
  ApiBlueprint,
  PageBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { DpsApiClient } from './api/DpsApiClient';
import { dpsApiRef } from './api/dpsApiRef';
import { DpsAccessGuard } from './components/DpsAccessGuard';
import { rootRouteRef } from './routes';

const dpsApi = ApiBlueprint.make({
  name: 'dps',
  params: define =>
    define({
      api: dpsApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new DpsApiClient({ discoveryApi, fetchApi }),
    }),
});

const dpsPage = PageBlueprint.make({
  name: 'dps',
  params: {
    path: '/dps',
    routeRef: rootRouteRef,
    loader: () =>
      import('./components/DpsPage').then(m => (
        <DpsAccessGuard>
          <m.DpsPage />
        </DpsAccessGuard>
      )),
  },
});

export default createFrontendPlugin({
  pluginId: 'dps',
  routes: { root: rootRouteRef },
  extensions: [dpsApi, dpsPage],
});
